
import { defineComponent } from "vue";
import Timer from "@/data/Timer";

export default defineComponent({
  name: "TimerBox",

  props: {
    timer: {
      type: Timer,
      required: true,
    },
    threshold: {
      type: Number,
      default: 1000,
    },
  },

  computed: {
    colorClass() {
      if (this.timer.isStopped) {
        return "color--grey";
      }
      if (this.timer.seconds > this.threshold) {
        return "color--red";
      } else if (
        this.timer.seconds > this.threshold * 0.85 &&
        this.timer.seconds <= this.threshold
      ) {
        return "color--orange";
      }
      return "color--white";
    },
    time() {
      return this.timer.time;
    },
    value() {
      return this.timer.value;
    },
    seconds() {
      return this.timer.seconds;
    },
    minutes() {
      return this.timer.minutes;
    },
  },
});
